"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyDataSettingsSection = void 0;
const stitches_config_1 = require("../../../../../stitches.config");
const Content_1 = require("../../../__styles__/Content");
exports.PropertyDataSettingsSection = (0, stitches_config_1.styled)(Content_1.Section, {
    variants: {
        propertyAttributes: {
            true: {
                paddingTop: "8px",
                paddingBottom: "32px",
            },
        },
        dfeRules: {
            true: {
                paddingTop: "32px",
                paddingBottom: "32px",
            },
        },
        sisdRules: {
            true: {
                paddingTop: "32px",
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL1NldHRpbmdzL0FjY291bnQvUHJvcGVydHlEYXRhL19fc3R5bGVzX18vaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsb0VBQXdEO0FBQ3hELHlEQUFzRDtBQUV6QyxRQUFBLDJCQUEyQixHQUFHLElBQUEsd0JBQU0sRUFBQyxpQkFBTyxFQUFFO0lBQ3pELFFBQVEsRUFBRTtRQUNSLGtCQUFrQixFQUFFO1lBQ2xCLElBQUksRUFBRTtnQkFDSixVQUFVLEVBQUUsS0FBSztnQkFDakIsYUFBYSxFQUFFLE1BQU07YUFDdEI7U0FDRjtRQUNELFFBQVEsRUFBRTtZQUNSLElBQUksRUFBRTtnQkFDSixVQUFVLEVBQUUsTUFBTTtnQkFDbEIsYUFBYSxFQUFFLE1BQU07YUFDdEI7U0FDRjtRQUNELFNBQVMsRUFBRTtZQUNULElBQUksRUFBRTtnQkFDSixVQUFVLEVBQUUsTUFBTTthQUNuQjtTQUNGO0tBQ0Y7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBzdHlsZWQgfSBmcm9tIFwiLi4vLi4vLi4vLi4vLi4vc3RpdGNoZXMuY29uZmlnXCI7XG5pbXBvcnQgeyBTZWN0aW9uIH0gZnJvbSBcIi4uLy4uLy4uL19fc3R5bGVzX18vQ29udGVudFwiO1xuXG5leHBvcnQgY29uc3QgUHJvcGVydHlEYXRhU2V0dGluZ3NTZWN0aW9uID0gc3R5bGVkKFNlY3Rpb24sIHtcbiAgdmFyaWFudHM6IHtcbiAgICBwcm9wZXJ0eUF0dHJpYnV0ZXM6IHtcbiAgICAgIHRydWU6IHtcbiAgICAgICAgcGFkZGluZ1RvcDogXCI4cHhcIixcbiAgICAgICAgcGFkZGluZ0JvdHRvbTogXCIzMnB4XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgZGZlUnVsZXM6IHtcbiAgICAgIHRydWU6IHtcbiAgICAgICAgcGFkZGluZ1RvcDogXCIzMnB4XCIsXG4gICAgICAgIHBhZGRpbmdCb3R0b206IFwiMzJweFwiLFxuICAgICAgfSxcbiAgICB9LFxuICAgIHNpc2RSdWxlczoge1xuICAgICAgdHJ1ZToge1xuICAgICAgICBwYWRkaW5nVG9wOiBcIjMycHhcIixcbiAgICAgIH0sXG4gICAgfSxcbiAgfSxcbn0pO1xuIl19